module.exports = __webpack_public_path__ + "img/LjpI9OyN5O.839e2f75.png";